export const DEACTIVATE_FILTER_PARAM = 'deactivate';
